(function ($) {
    var pluginName = 'mdbNumericInput';
    
    var validKeyCodes = [
        8,   //Backspace
        9,   //Tab
        16,  //Shift
        17,  //Control
        27,  //Escape
        33,  //PageUp
        34,  //PageDown
        35,  //End
        36,  //Home
        37,  //Arrow left
        39,  //Arrow right
        46,  //Delete
        100, //Arrow left (alternate)
        102, //Arrow right (alternate)
        110, //Delete (alternate)
        189, //-
        
        //Should always be allowed, just in case
        // 144, //.
        188, //,
        190, //. (alternate)

        //0 - 9
        48,
        49,
        50,
        51,
        52,
        53,
        54,
        55,
        56,
        57,

        //0 - 9 (alternate)
        96,
        97,
        98,
        99,
        100,
        101,
        102,
        103,
        104,
        105,
        
        //F1 - F12
        112,
        113,
        114,
        115,
        116,
        117,
        118,
        119,
        120,
        121,
        122,
        123
    ];

    //Separate whitelist for keys when the ctrl key is pressed
    //These would normally trigger actual input
    var validControlKeyCodes = [
        65,  //a
        67,  //c
        86,  //v
        89,  //y
        90,  //z
    ];
    
    $.fn[pluginName] = function (config) {
        config = config || {};
        
        var culture = MDB.currentCulture();
        
        config = {
            numberFormat: culture.numberFormat,
            precision: config.precision
        };
        
        this.each(function(){
            var input = this
                , $input = $(input)
                , elementId = input.id + '_' + pluginName 
                , label = document.querySelector('label[for="' + input.id + '"]')
                , element = document.createElement('input')
                , $element = $(element);
            
            element.type = 'text';
            element.id = elementId;
            element.className = 'form-control mdb-control mdb-numeric-input';
            
            //Clicking on the label should focus our new element instead of the (soon to be hidden) control
            if(label){
                label.setAttribute('for', elementId);
            }
            
            //Config should be leading as per convention, otherwise look in DOM dataset for precision
            var precision = config.precision;
            if(precision === undefined || isNaN(config.precision)){
                precision = this.dataset['precision'];
            }
            
            precision = isNaN(precision) ? 0 : parseInt(precision);
            
            var numericTextBox = {
                _numberFormat: config.numberFormat,
                _parseValueRegex: generateValueParseRegex(config.numberFormat, precision),
                _decimalSeparatorCharCode: config.numberFormat.decimalSeparator.charCodeAt(0),
                _fieldValue: '',
                
                _parseValue: function(value){
                    var parseResult = this._parseValueRegex.exec(value);
                    if(parseResult && parseResult[0]){
                        return parseResult[0];
                    }
                    
                    //Setting undefined as the element value actually displays 'undefined'
                    //Hence we should return an empty string
                    return '';
                },
                set numberFormat(format){
                    this._numberFormat = format;
                    this._parseValueRegex = generateValueParseRegex(format, precision);
                },
                get numberFormat(){
                    return this._numberFormat;
                },
                get input(){
                    return $input;
                },
                get element() {
                    return $element;
                },

                value: function(value){
                    //Get operation, return value
                    if(value === undefined){
                        //Only parse the value when no fieldValue is present
                        //This should only happen when either the textbox is empty or it is the first call 
                        return this._fieldValue || (this._fieldValue = this._parseValue(input.value));   
                    }

                    //Only parse when it's actually different from our current field value
                    if(this._fieldValue !== value){
                        value = this._parseValue(value);
                    }
                    
                    //Only '.' is supported for floating point values
                    var inputValue = value.replace(this._numberFormat.decimalSeparator, '.');

                    //Nothing changed, move along...
                    if(element.value === value && input.value === inputValue){
                        return;
                    }

                    this._fieldValue = element.value = value;
                    input.value = inputValue;
                }
            };
            
            //Plugin should always be approachable by name
            $input.data(pluginName, numericTextBox);
           
            //Ensure a valid value is entered beforehand
            numericTextBox.value(
                numericTextBox._parseValue(input.value)
            );

            $element.on('keydown', function(e){
                //Either a standard valid keycode
                //A valid control keyCode when control is pressed
                //Or the configured decimal separator
                return validKeyCodes.indexOf(e.keyCode) !== -1 ||
                   (e.ctrlKey && validControlKeyCodes.indexOf(e.keyCode) !== -1) ||
                   e.keyCode === numericTextBox._decimalSeparatorCharCode;
            });

            $element.on('change keyup paste', function(e){
                numericTextBox.value(this.value);
            });

            input.type = 'hidden';
            $element.insertAfter($input);
        });
        
        return this;
    };
    
    function generateValueParseRegex(numberFormat, precision){
        //123
        //-123
        var pattern = '^-?\\d+';

        if(precision){
            //.23
            //(\.\d{0,2})?
            pattern += '(\\' + numberFormat.decimalSeparator + '\\d{0,' + precision + '})?'
        }
        
        //-123.23
        //123.23
        //-0.23
        //0.23
        //-123
        //123
        //-?\d+(\.\d+)?
        return new RegExp(pattern);
    }
}(jQuery));